import React from 'react';
import SectionWrapper from '../layout/SectionWrapper';

export default function Contact() {
  return (
    <SectionWrapper id="contact" className="relative bg-black/20 backdrop-blur-sm border-t border-white/10 py-28">
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white font-poppins text-center">
        Contact
      </h2>
      <div className="bg-white/5 rounded-2xl shadow-md backdrop-blur-lg p-8 flex flex-col gap-5 border border-white/10 max-w-lg mx-auto">
        <ContactRow
          label="📧 Email"
          value="aniketnshukla.dev@gmail.com"
          href="mailto:aniketnshukla.dev@gmail.com"
        />
        <ContactRow
          label="💼 LinkedIn"
          value="linkedin.com/in/AniketnShukla"
          href="https://www.linkedin.com/in/AniketnShukla"
        />
        <ContactRow
          label="💻 GitHub"
          value="github.com/AniketnShukla"
          href="https://github.com/AniketnShukla"
        />
        {/* Optional Resume Link */}
        {/* <ContactRow
          label="🧾 Resume"
          value="Download PDF"
          href="/resume.pdf"
        /> */}
      </div>
    </SectionWrapper>
  );
}

function ContactRow({ label, value, href }) {
  return (
    <p className="text-base text-slate-200 font-inter">
      <b>{label}:</b>{' '}
      <a href={href} target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:underline">
        {value}
      </a>
    </p>
  );
}
